import {Component} from '@angular/core';

@Component({
  selector: 'app-accounting-aggregation-help',
  standalone: true,
  imports: [],
  templateUrl: './accounting-aggregation-help.component.html',
  styleUrl: './accounting-aggregation-help.component.scss'
})
export class AccountingAggregationHelpComponent {

}
